import { ROUTE_PARAMS } from "@/constants";
import { Navigate, useParams } from "react-router";

export default function NavigateToAccessDenied() {
  const { [ROUTE_PARAMS.ACCOUNT_ID]: accountId } = useParams();

  if (accountId === undefined || accountId === "") {
    return null;
  }

  return (
    <Navigate to={`/${accountId}/${ROUTE_PARAMS.ACCESS_DENIED}`} replace />
  );
}
